/** @module form */

import { eventListenerOptions } from '@spinnwerk/polyfills';

function getChildren(el) {
    el = el.closest('li');
    el = el && el.querySelector('ul');
    return (el && el.querySelectorAll('input[type="checkbox"]')) || [];
}

function getParent(el) {
    el = el.closest('ul');
    el = el && el.closest('li');
    return el && el.querySelector('input[type="checkbox"]');
}

function updateChildren(el) {
    const { checked } = el;

    getChildren(el).forEach(child => {
        child.checked = checked;
        child.indeterminate = false;
    });
}

function updateParents(parent) {
    while ((parent = getParent(parent))) {
        let children = getChildren(parent),
            checked = [...children].filter(child => child.checked).length;

        parent.checked = checked === children.length;
        parent.indeterminate = checked && !parent.checked;
    }
}

function onInputChange(event) {
    updateChildren(event.target);
    updateParents(event.target);
}

/**
 * Should not be referenced directly.
 *
 * @param {NodeList<HTMLInputElement>} checkboxes
 *
 * @private
 * @see {@link hierarchicalCheckboxes}
 */
export function initHierarchicalCheckboxes(checkboxes) {
    checkboxes.forEach(cb => {
        cb.addEventListener('change', onInputChange, eventListenerOptions({ passive: true }));
    });
}
